import { create } from 'zustand';

import { withResolvers } from '@/shared/utils/promises';

type LoadingStatus = 'none' | 'initializing' | 'inited';

type CollectionsStatusState = {
  status: LoadingStatus;
  isReadyForInit: boolean;
  syncing: boolean;
  isMigrationError: boolean;
  awaitInited: Promise<boolean>;
};

type CollectionsStatusStore = CollectionsStatusState & {
  setSyncing: (syncing: boolean) => void;
  setReadyForInit: () => void;
  setStatus: (status: LoadingStatus) => void;
  setIsMigrationError: (isMigrationError: boolean) => void;
};

const getInitialState = (promise: Promise<boolean>): CollectionsStatusState => ({
  status: 'none',
  isReadyForInit: false,
  syncing: false,
  isMigrationError: false,
  awaitInited: promise,
});

export const useCollectionsStatusStore = create<CollectionsStatusStore>((set) => {
  const promiseResolvers = withResolvers<boolean>();

  return {
    ...getInitialState(promiseResolvers.promise),

    setSyncing: (syncing) => set({ syncing }),
    setReadyForInit: () => set({ isReadyForInit: true }),
    setStatus: (status) => {
      if (status === 'inited') {
        promiseResolvers.resolve(true);
      }
      set({ status });
    },
    setIsMigrationError: (isMigrationError) => set({ isMigrationError }),
  };
});
